/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
export var StyledTopControls = styled('div')(function () {
  return {
    '.EmbersTableTopControls-SearchAndFilter': {},
    '.EmbersTableTopControls-Indicators': {
      display: 'flex',
      alignItems: 'center',
      height: 40,
      '.EmbersTableTopControls-CountText': {
        marginRight: 16
      },
      '.EmbersRefreshButton-root': {
        marginLeft: 'auto'
      }
    }
  };
});